import { NgModule } from '@angular/core';
import { PartnersContactModalComponent } from './partners-contact-modal.component';

@NgModule({
  declarations: [],
  imports: [PartnersContactModalComponent],
  exports: [PartnersContactModalComponent]
})
export class PartnersContactModalModule {}
